import React, { useEffect, useState } from 'react';
import { db } from '../Firebase';
import "./OrderAdmin.css";
import OrderAdminRow from "./OrderAdminRow"
import Sidebar from './Sidebar';

function OrderAdmin() {
    const [adminOrders, setAdminOrders] = useState([])
    useEffect(()=>{
        db.collection('users').onSnapshot((snapshot)=>{
            snapshot.docs.forEach((data)=>
                db.collection('users').doc(data.id).collection('orders').onSnapshot((snapshot)=>{
                
                    setAdminOrders(snapshot.docs.map((doc)=>({
                        id:doc.id,
                        total:doc.data().amount,
                        date:doc.data().created
                    })))
                })  
            )
        })
    }, [])
    



    return (
        <div className="orderAdmin">
            <Sidebar />
          <div className="otherContent">
            <div className="upperContent">
                <h2>OrderList</h2>
                <div className="Order__heading">
                    <h3 className="order__ID">Order ID</h3>
                    <h3>Date</h3>
                    <h3>Amount</h3>
                    <h3>Order Status</h3>
                </div>
            </div>
            <div className="orderListContainer">
                {adminOrders.map(({id, total, date})=>(
                    <OrderAdminRow key={id} id={id} total={total} date={date}/>
                ))} 
                <br />
            </div>
           </div>
            
        </div>
    )
}

export default OrderAdmin
